import React, { useMemo } from 'react';
import * as ReactBootstrap from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../redux/configureStore';
import Wrapper from '../../../../shared/components/Wrapper';
import Frame from './components/Frame';
import TransferFilter from './components/TransferFilter';
import TransfersTableList from './components/TransferTableList';

function TransferApp() {
  const transferListContext = useSelector(
    (reducer: IReducer) => reducer.transfersApp
  );

  const loading = useMemo(() => {
    if (transferListContext.isLoading === true) {
      return (
        <Wrapper.Default margin="20% 0 0 0" isActive>
          <ReactBootstrap.Spinner animation="border" />
        </Wrapper.Default>
      );
    }
    return <></>;
  }, [transferListContext.isLoading]);

  return (
    <Frame.Base>
      <TransferFilter />
      {loading}
      {transferListContext.isActive && <TransfersTableList />}
    </Frame.Base>
  );
}

export default TransferApp;
